var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [
          _vm._v(
            _vm._s(
              _vm.form.id ? "Editar movimiento de caja" : "Movimiento de caja"
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "valor_abono",
                  vMoney: "",
                  format: _vm.money,
                  placeholder: "Escriba un valor..."
                },
                model: {
                  value: _vm.form.valor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "valor", $$v)
                  },
                  expression: "form.valor"
                }
              },
              [
                _vm._v("\n\t\t\t\t\t$ Valor\n\t\t\t\t\t"),
                _vm.errores.valor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.valor[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha",
                  locale: "es",
                  "no-label": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD HH:mm:ss",
                  formatted: "YYYY-MM-DD HH:mm:ss",
                  label: "Seleccione fecha..."
                },
                model: {
                  value: _vm.form.fecha,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha", $$v)
                  },
                  expression: "form.fecha"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha")]),
              _vm._v(" "),
              _vm.errores.fecha
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.fecha[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  clearable: false,
                  placeholder: "Seleccione...",
                  id: "tipo_movimiento",
                  options: _vm.tiposMovimiento,
                  index: "value"
                },
                model: {
                  value: _vm.form.tipo_movimiento,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tipo_movimiento", $$v)
                  },
                  expression: "form.tipo_movimiento"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_movimiento" } }, [
                _vm._v("Tipo de movimiento")
              ]),
              _vm._v(" "),
              _vm.errores.tipo_movimiento
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.tipo_movimiento[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  clearable: false,
                  placeholder: "Seleccione...",
                  id: "tipo_caja",
                  options: _vm.tiposCaja,
                  index: "value"
                },
                model: {
                  value: _vm.form.tipo_caja,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tipo_caja", $$v)
                  },
                  expression: "form.tipo_caja"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_caja" } }, [
                _vm._v("Tipo de caja")
              ]),
              _vm._v(" "),
              _vm.errores.tipo_caja
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.tipo_caja[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  clearable: false,
                  placeholder: "Seleccione...",
                  id: "ruta_id",
                  options: _vm.rutas,
                  label: "descripcion",
                  index: "id"
                },
                model: {
                  value: _vm.form.ruta_id,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "ruta_id", $$v)
                  },
                  expression: "form.ruta_id"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ruta_id" } }, [_vm._v("Ruta")]),
              _vm._v(" "),
              _vm.errores.ruta_id
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.ruta_id[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: {
                  placeholder: "Escriba una observación...",
                  id: "observacion"
                },
                model: {
                  value: _vm.form.observacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "observacion", $$v)
                  },
                  expression: "form.observacion"
                }
              },
              [
                _c("span", [_vm._v("Observación")]),
                _vm._v(" "),
                _vm.errores.observacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.observacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d3375d7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3375d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/movimientos/MovimientoPrestamo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1d3375d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/movimientos/MovimientoPrestamo.vue
// module chunks = 0